import { StyledArrowButton } from '@/components/styles'
import Icon from '@/assets/icons'

export default function ArrowButton(props) {
  return (
    <StyledArrowButton {...props} >
      <Icon name="arrow-left" />
    </StyledArrowButton>
  )
}
